import React from 'react';
import { Starfield } from './Starfield';
import { Nebula } from './Nebula';
import { Particles } from './Particles';

export const Background: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-dark overflow-hidden pointer-events-none" style={{ zIndex: 0 }}>
      {/* Starfield layer */}
      <Starfield />

      {/* Nebula layers with parallax */}
      <Nebula />

      {/* Floating particles */}
      <Particles />

      {/* Gradient overlay for depth */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom, rgba(10,10,10,0) 0%, rgba(10,10,10,0.5) 100%)',
          zIndex: 4,
        }}
      />
    </div>
  );
};
